export default __webpack_public_path__ + "static/media/break-into.png.webp";